import { Pipe, PipeTransform } from '@angular/core';
import { ThingsUtil } from '../../../util/things';

@Pipe({
  name: 'formatThingType',
  pure: true
})
export class formatThingTypePipe implements PipeTransform {

  constructor(private thingsUtil: ThingsUtil) {}

  transform(value: string): string {
    if (!value) {
      return value;
    }

    return this.thingsUtil.getLabelForType(value);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/details/formatType.pipe.ts